export type ProductWorkspace = {
  organizerId: string;
  organizerName: string;
  serviceProductId: string;
  productName: string;
  enabled: boolean;
  subscriptionStatus: string;
  accessMode?: "ACTIVE" | "VIEW_ONLY";
  expiresAtEpochMillis: number | null;
  freeForLife?: boolean;
  capabilities: string[];
};
export type WorkspacePage = { items: ProductWorkspace[]; nextCursor: string | null };
export function parseWorkspacePage(value: unknown): WorkspacePage {
  if (!value || typeof value !== "object") throw new Error("Invalid product workspaces");
  const page = value as WorkspacePage;
  if (!Array.isArray(page.items) || (page.nextCursor !== null && typeof page.nextCursor !== "string") ||
    page.items.some((item) => !item || typeof item !== "object" ||
      [item.organizerId, item.organizerName, item.serviceProductId, item.productName, item.subscriptionStatus].some((s) => typeof s !== "string" || !s) ||
      typeof item.enabled !== "boolean" || (item.expiresAtEpochMillis !== null && !Number.isFinite(item.expiresAtEpochMillis)) ||
      (item.accessMode !== undefined && !["ACTIVE", "VIEW_ONLY"].includes(item.accessMode)) ||
      (item.freeForLife !== undefined && typeof item.freeForLife !== "boolean") ||
      !Array.isArray(item.capabilities) || item.capabilities.some((p) => typeof p !== "string")))
    throw new Error("Invalid product workspaces");
  return page;
}
export function canManageWorkspace(item: ProductWorkspace, now = Date.now()): boolean {
  return item.enabled && item.accessMode !== "VIEW_ONLY" && item.subscriptionStatus === "ACTIVE" &&
    (item.freeForLife === true ? item.expiresAtEpochMillis === null :
      typeof item.expiresAtEpochMillis === "number" && item.expiresAtEpochMillis > now) && item.capabilities.includes("events.manage");
}
/** Historical access is an explicit server grant, never inferred from an unpaid invoice. */
export function canReadWorkspace(item: ProductWorkspace, now = Date.now()): boolean {
  if (canManageWorkspace(item, now)) return true;
  if (!item.enabled || !item.capabilities.includes("events.read")) return false;
  if (item.accessMode === "VIEW_ONLY" && item.subscriptionStatus === "EXPIRED") return true;
  return item.subscriptionStatus === "ACTIVE" && item.accessMode !== "VIEW_ONLY" &&
    (item.freeForLife === true ? item.expiresAtEpochMillis === null :
      typeof item.expiresAtEpochMillis === "number");
}
export function workspaceKey(item: Pick<ProductWorkspace, "organizerId" | "serviceProductId">): string {
  return new URLSearchParams({ organizerId: item.organizerId, serviceProductId: item.serviceProductId }).toString();
}
export function workspaceProductName(item: Pick<ProductWorkspace, "serviceProductId" | "productName">, w: (ar: string, en: string) => string): string {
  return item.serviceProductId === EDUCATION_VOTING_PRODUCT
    ? w("خدمة التصويت", "Voting service")
    : item.productName;
}
export function findWorkspace(items: ProductWorkspace[], organizerId: string, serviceProductId: string, now = Date.now()) {
  return items.find((item) => item.organizerId === organizerId && item.serviceProductId === serviceProductId && canReadWorkspace(item, now));
}
import { EDUCATION_VOTING_PRODUCT } from "./education.ts";
